export default function formatMobileNumber(number) {
    return number?.replace(/\D/g, '') ?? '';
}